import { ClpApiService } from './service/ClpApiService';

export const clpApiService = new ClpApiService();

export interface IClpApiDependencySegment {
  clpApi: ClpApiService;
}
